/**
 * Shared helper for applying token transforms.
 *
 * Pure pass-through to {@link applyArrayTokenTransforms}; the store wiring
 * lives in the `useApplyTokenTransforms` hook for surfaces that have a
 * React context to read from.
 */

import type { Token } from '@/types/valueSegment';
import {
  applyArrayTokenTransforms,
  type ApplyArrayTokenTransformsContext,
} from './arrayTokens';

export type { ApplyArrayTokenTransformsContext };

export function applyTokenTransforms(
  token: Token,
  ctx: ApplyArrayTokenTransformsContext,
): Token {
  return applyArrayTokenTransforms(token, ctx);
}
